import React from 'react';
import Input from 'components/Input/Input';

type Props = {
  onChange: Function;
  value: string;
};

export function Search({ onChange, value }: Props) {
  return (
    <Input
      type="text"
      placeholder="Search by ship name"
      onChange={onChange}
      value={value}
    />
  );
}
